import { GetVisibilityIntervalsService } from '../Persistencia/VisibilityIntervalsService'

interface IVisibilityIntervalsData {
  status: number,
  data: string[]
}
export async function GetVisibilityIntervalsUtility(): Promise<IVisibilityIntervalsData> {
  try {
    const { data, status } = await GetVisibilityIntervalsService();

    if (
      status !== 1 || 
            data.statusCode !== 200 || 
            typeof data.body === 'string' ) {
      return {
        data: [],
        status: 0
      };
    }

    return {
      data: data.body.data,
      status: status
    };
  } catch ( error: unknown ) {
    return {
      data: [],
      status: 0
    };
  }
}